module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-b13b59d7.png";